import { TDeviceType } from '@cian/ui-kit';

import { IApplicationState } from '../../types/redux';

export const selectDeviceType = (state: IApplicationState): TDeviceType => {
  const { page } = state;

  return page.deviceType;
};
